import createPersistedState from 'vuex-persistedstate'

/**
 * Our store definition
 */
export default {

    plugins: [createPersistedState({
        key: 'userState',
        paths: ['user'],
    })],

    modules: {
        account: require('./stores/account.js').default,
        intercom: require('./stores/intercom.js').default,
        listings: require('./stores/listings.js').default,
        modals: require('./stores/modals.js').default,
        user: require('./stores/user.js').default,
        findspace: require('./stores/findspace.js').default,
    },

    state: {
        window: {
            height: (window.visualViewport) ? window.visualViewport.height : window.innerHeight,
            width: (window.visualViewport) ? window.visualViewport.width : window.innerWidth,
        },
    },

    getters: {

        isDesktop (state) {
            return (state.window.width >= 1200)
        },

        isMobile (state) {
            return (state.window.width < 768)
        },

        isMobilePortrait (state) {
            return (state.window.width < 480)
        },

        isMobileLandscape (state) {
            return (state.window.width >= 480) && (state.window.width < 768)
        },

        isTablet (state) {
            return (state.window.width < 1200)
        },

        isTabletPortrait (state) {
            return (state.window.width >= 768) && (state.window.width < 1024)
        },

        isTabletLandscape (state) {
            return (state.window.width >= 1024) && (state.window.width < 1200)
        },
    },

    mutations: {

        /**
         * Handle when our window is resized / recalculate mobileness.
         */
        resizeWindow (state) {
            state.window.height = (window.visualViewport) ? window.visualViewport.height : window.innerHeight
            state.window.width = (window.visualViewport) ? window.visualViewport.width : window.innerWidth
        },

    },

    actions: {

        //action(context) {
        //},

    },

}
